import gsap, { Power2 } from 'gsap';
import { Basics } from '../_app/cuchillo/core/Basics';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';

class ScrollItem__ProjectList extends Scroll_Item {
  _filters;
  _projects;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._filters = GetBy.class('__filter', __link);
    this._projects = GetBy.class('__project', __link);
    gsap.set(this._projects, { opacity: 0 });

    this._click = (e) => this.filter(e);
    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].addEventListener(Basics.clickEvent, this._click);
    }

    this.onShow = () => {
      for (let i = 0; i < this._projects.length; i++) {
        const p = this._projects[i];

        gsap.to(p, {
          opacity: 1,
          duration: 1,
          delay: .4 + .1 * i,
          ease: Power2.easeOut
        });
      }

    };
    this.onHide = () => {};
    this.onMove = () => {};
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  filter (e) {
    const btn = e.target;

    for (let i = 0; i < this._filters.length; i++) {
      const f = this._filters[i];

      if (f !== btn) f.classList.remove('--active');
      else f.classList.add('--active');
    }

    const filter = `categ-${btn.dataset.categ}`;

    gsap.to(this._projects, {
      opacity: 0,
      duration: .2,
      onComplete: () => {
        for (let i = 0; i < this._projects.length; i++) {
          const p = this._projects[i];
    
          if (p.classList.contains(filter)) {
            p.style.display = 'block';
            gsap.to(p, {
              opacity: 1,
              duration: .8,
              ease: Power2.easeOut
            });
          } else {
            p.style.display = 'none';
          }
        }

        Scroll.resize();
      }
     });
  }

  dispose () {
    super.dispose();
    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].removeEventListener(Basics.clickEvent, this._click);
    }
  }
}

Scroll._registerClass('project-list', ScrollItem__ProjectList);

export default ScrollItem__ProjectList;
